import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

/**
 * 근무자가 갈 수 있는 곳.
 *
 * 예전에는 담당 시설의 점검 포털 하나로 몰아넣었다. 그 화면은 구역을 늘어놓을
 * 뿐 무엇이 남았는지 말하지 못하고, 담당 시설이 없는 사람은 갈 데조차 없었다
 * (`assignedFacilities?.[0]?.id || 0` -> /facilities/0/inspection).
 *
 * 이제 시작점은 '오늘 할 점검' 이다. 거기서 이슈를 올리고 자기 기록을 열 수
 * 있어야 하므로 그 길들을 함께 연다.
 */
const STAFF_PATHS = ['/today', '/reports', '/issues', '/new', '/settings', '/help'];

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (
    user.role === 'STAFF' &&
    !STAFF_PATHS.some((p) => location.pathname.startsWith(p))
  ) {
    return <Navigate to="/today" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
